import type { SupabaseClient } from '@supabase/supabase-js';
import { renderLogTab } from './tabs/log.js';

// Standalone-Log-Fenster für den Vario-Verkaufskanal-Tab (Slot
// settings.sales-channels.{appId}.tabs → /#/log). Rendert das Aktivitäts-Log
// (gambio.activity_log) im go-eCommerce-Design. Anders als der Orders-Tab baut
// renderLogTab seinen Header selbst (renderKfPage) - daher KEIN headerHtml und
// keine *-fullpage-Klasse; renderKfPage koppelt die Höhe via fitViewport an die
// (von Vario per useFullHeight gelieferte) volle Viewport-Höhe.
interface LogPageContext {
  contentEl: HTMLElement;
  supabase: SupabaseClient;
  session: { token: string; tenantId: string; marketplaceKind: string };
  supabaseUrl: string;
}

export async function renderLogPage(ctx: LogPageContext): Promise<void> {
  ctx.contentEl.hidden = false;

  // Ancestor-Kette auf 100% (html → body → #app → #content), damit das Fenster
  // die volle Viewport-Höhe füllen kann.
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  const appEl = document.getElementById('app');
  if (appEl) appEl.style.height = '100%';
  ctx.contentEl.style.height = '100%';

  renderLogTab(ctx.contentEl, {
    supabase: ctx.supabase,
    session: { token: ctx.session.token, tenantId: ctx.session.tenantId },
    supabaseUrl: ctx.supabaseUrl,
  });
}
